import { ComponentProps, FC } from 'react';
import styleToCss from 'style-object-to-css-string';
import styled from 'styled-components';
import { allProps, Box } from '@altermaind/web/ui';

type Props = ComponentProps<typeof Box> & {
  isCollapsed: boolean;
  isCollapsedOnDefault: boolean;
};

export const StyledCollapsableCardContent = styled.div<Props>(
  ({ isCollapsed, isCollapsedOnDefault }) => `
  & > * {
    ${styleToCss(
      isCollapsed
        ? {
            overflow: 'hidden',
          }
        : {
            animation: isCollapsedOnDefault ? 'hide-scroll-animation 2.5s' : undefined,
          },
    )}
  }
`,
  allProps,
) as FC<Props>;
